import { Controller } from "@hotwired/stimulus"

// PR-A2: Shift modal-form UX
// Toont 'Los / op aanvraag' badge naast 'Shift Category' label wanneer de
// geselecteerde category in OPT_IN_CATEGORIES (admin, absent, on_request) zit.
// Adresseert planner-verwarring: deze shifts mogen weekdays leeg hebben en
// worden niet door de solver gepland (Shift#optional_for_solver?).
export default class extends Controller {
  static targets = ["select", "badge"]
  static values = { optInCategories: Array }

  connect() {
    this.updateBadge()
  }

  categoryChanged() {
    this.updateBadge()
  }

  updateBadge() {
    if (!this.hasBadgeTarget || !this.hasSelectTarget) return
    const current = this.selectTarget.value
    const isOptIn = this.optInCategoriesValue.includes(current)
    this.badgeTarget.classList.toggle("hidden", !isOptIn)
  }
}
